import { Component, OnInit } from '@angular/core';
import {TooltipBaseComponent} from '../tooltip-base/tooltip-base.component';

@Component({
  selector: 'app-tooltip-period',
  templateUrl: './tooltip-period.component.html',
  styleUrls: ['./tooltip-period.component.scss']
})
export class TooltipPeriodComponent extends TooltipBaseComponent implements OnInit {

  ngOnInit(): void {}

}
